export const SUPPORT_EMAIL = 'support@pixlide.com';

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
